import React from "react";
import FormItem from "./FormItem";

export default function FormsTable({ products, handleProductSelection, children, navigateTo }) {
  return (
    <>
      <div className="mx-auto max-w-3xl w-full space-y-0.5 mt-16">
        {children && <h1 className="font-bold mb-4 text-center text-xl text-[#005b95]">
          {children}
        </h1>}
        {products.map((product) => {
          return (
            <FormItem
              key={product.id}
              navigateTo={navigateTo}
              handleProductSelection={handleProductSelection}
              product={product}
            />
          );
        })}
      </div>
    </>
  );
}
